module.exports = __webpack_public_path__ + "static/osiris_03-8fc24ba873bff174cc67e7693d1948c7.jpg";